import React from "react";
import images from "../../../../utilities/images/images";
import "./StreakMilestone.css";

const DEFAULT_MILESTONES = [
  { id: 1, title: "Week Warrior", daysRequired: 7, badgeValue: 7, achieved: true, active: true, multiplier: "x1" },
  { id: 2, title: "Fortnight Fighter", daysRequired: 15, badgeValue: 15, achieved: true, multiplier: "x2" },
  { id: 3, title: "Monthly Master", daysRequired: 30, badgeValue: 30, achieved: true, multiplier: "x3" },
  { id: 4, title: "Legend", daysRequired: 100, badgeValue: 100, achieved: false, locked: true, multiplier: "x4" },
];

function StreakMilestone({ title = "Milestone Collection", titleSuffix, milestones }) {
  const cards = Array.isArray(milestones) && milestones.length > 0
    ? milestones.map((item, index) => {
        const statusText = item?.status || "";
        const achieved = statusText.toLowerCase() === "achieved" || item?.is_achieved === true;
        return {
          id: `${item?.badge_name || "badge"}-${index}`,
          title: item?.badge_name,
          required: item?.required_days,
          badgeUrl: item?.streak_url,
          multiplier: `x${item?.achieved_count}`,
          achieved,
          statusText,
          active: index === 0,
          locked: !achieved,
        };
      })
    : DEFAULT_MILESTONES;

  return (
    <section className="streak-milestone">
      <h3 className="streak-milestone__title">
        {title}
        {titleSuffix ? <span className="streak-milestone__title-suffix">{titleSuffix}</span> : null}
      </h3>

      <div className="streak-milestone__cards" role="list" aria-label="Milestone collection cards">
        {cards.map((item) => (
          <article
            key={item.id}
            className={`streak-card${item.active ? " streak-card--active" : ""}${item.locked ? " streak-card--locked" : ""}`}
            role="listitem"
          >
            <div className="streak-card__badge-wrap">
              <span className="streak-card__multiplier">{item.multiplier}</span>
              {item.badgeUrl ? (
                <img src={item.badgeUrl} alt="" className="streak-card__badge-image" aria-hidden="true" />
              ) : (
                <div className="streak-card__badge" aria-hidden="true">
                  {item.badgeValue}
                </div>
              )}
            </div>

            <h4 className="streak-card__name">{item.title}</h4>
            <p className="streak-card__required">{item.required || `${item.daysRequired} Days Required`}</p>

            {item.achieved ? (
              <span className="streak-card__status streak-card__status--achieved">{item.statusText || "Achieved"}</span>
            ) : (
              <span className="streak-card__status streak-card__status--locked">
                <img
                  src={images.engage_lock_icon}
                  alt="Locked milestone"
                  className="streak-card__lock-icon"
                  width={22}
                  height={22}
                />
              </span>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}

export default StreakMilestone;
export { StreakMilestone as StreakMilestonePreview };
